/* oxlint-disable no-console */
import * as Sentry from '@sentry/react';
import Config from 'src/common/Config';

// Sentry omits keys with null or undefined values, so we convert them to string equivalents
function sanitizeValue(value: unknown): unknown {
  if (value === null) return '-> null';
  if (value === undefined) return '-> undefined';
  return value;
}

function sanitizeExtra(data?: { [key: string]: unknown }): { [key: string]: unknown } {
  if (!data) return {};
  return Object.entries(data).reduce(
    (acc, [key, value]) => {
      acc[key] = sanitizeValue(value);
      return acc;
    },
    {} as { [key: string]: unknown },
  );
}

export class Logger {
  static error(message: string, error: unknown, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.error(`${message}. ${JSON.stringify(data)}`, error);
    }
    Sentry.captureException(error, { extra: { message, ...sanitizeExtra(data) } });
  }

  static warn(message: string, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.warn(`${message}. ${JSON.stringify(data)}`);
    }
    Sentry.captureMessage(message, {
      level: 'warning',
      extra: sanitizeExtra(data),
    });
  }

  static info(message: string, data?: { [key: string]: unknown }): void {
    if (Config.isDev()) {
      console.info(`${message}. ${JSON.stringify(data)}`);
    }
    Sentry.addBreadcrumb({
      message,
      data,
      level: 'info',
    });
  }
}
